import type { OnboardingStep } from '@/state/onboarding/useOnboarding';

type StepsParams = { isAgency: boolean };

export type StepDescriptor = { key: OnboardingStep; label: string };

/**
 * The steps a new account goes through, in order. An agency's second step is its own website,
 * which the agency fee includes; its clients are added later, each with a plan of its own.
 */
export const onboardingSteps = ({ isAgency }: StepsParams): StepDescriptor[] => [
  { key: 'plan', label: isAgency ? 'Choose the agency fee' : 'Choose a plan' },
  { key: 'website', label: isAgency ? 'Add your own website' : 'Add your website' },
];
